// eslint-disable-next-line jira/filename-case
import { useCallback } from 'react';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { useFlagsService, type FlagConfiguration } from '@atlassian/jira-flags';
import type { MutationError } from '@jira/platform__utils-mutation-error/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
/* eslint-disable jira/i18n/no-export-define-message */
/* eslint-disable jira/filename-case */
// eslint-disable-next-line no-restricted-imports
import { defineMessage } from '@atlassian/jira-intl';

const defaultErrorMessage = defineMessage({
	id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-message',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Check your connection and try again.',
	description:
		'Flag description informing the user that setting their navigation customisation preference has failed.',
});

const defaultErrorTitle = defineMessage({
	id: 'jira-navigation-apps-sidebar-nav4-projects-customise-order.default-error-title',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: "We couldn't update your view.",
	description:
		'Flag title informing the user that setting their navigation customisation preference has failed.',
});

const FLAG: FlagConfiguration = {
	type: 'error',
	title: defaultErrorTitle,
	description: defaultErrorMessage,
	// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
	messageId:
		'navigation-apps-sidebar-nav4-projects-customise-order.services.update-favourite-order.flag.error',
	messageType: 'transactional',
};

export function useHandleError(): (error: MutationError) => void {
	const { showFlag } = useFlagsService();

	const handleError = useCallback(
		(error: MutationError) => {
			fireErrorAnalytics({
				meta: {
					id: 'useUpdateFavouriteOrder',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			showFlag(FLAG);
		},
		[showFlag],
	);

	return handleError;
}
